/* eslint-disable indent */

import { logError } from '@/utils/logHandling';

const generateConfig = (data, text, isThree, shouldDisplay = true) => {
  const labels = isThree
    ? ['Richtig', 'Falsch', 'Fast']
    : ['Richtig', 'Falsch'];
  const backgroundColor = isThree
    ? ['#51BF92', '#de4747', '#F0B840']
    : ['#51BF92', '#de4747'];

  return {
    type: 'doughnut',
    data: {
      labels,
      datasets: [
        {
          data,
          backgroundColor: backgroundColor,
        },
      ],
    },
    options: {
      responsive: true,
      legend: {
        display: shouldDisplay,
        position: 'left',
        labels: {
          boxWidth: 12,
        },
      },
      title: {
        display: shouldDisplay,
        text,
      },
    },
  };
};

export const createActiveDoghnutConfig = (stats, shouldDisplay) => {
  if (stats === null) return;
  const {
    /*print,
    thumbnail_url,
    active,*/
    Verstehen,
    Sprechen,
    Schreiben,
    Lesen,
  } = stats;

  // Verstehen
  const understandingConfigParams = [Verstehen.Richtig, Verstehen.Falsch];
  const understandingConfig = generateConfig(
    understandingConfigParams,
    'Auditives Sprachverständnis',
    false,
    shouldDisplay,
  );

  // Sprechen
  const speakingConfigParams = [
    Sprechen.Richtig,
    Sprechen.Falsch,
    Sprechen.Fast,
  ];
  const speakingConfig = generateConfig(
    speakingConfigParams,
    'Mündliches Benennen',
    true,
    shouldDisplay,
  );

  // Schreiben
  const writingConfigParams = [
    Schreiben.Richtig,
    Schreiben.Falsch,
    Schreiben.Fast,
  ];
  const writingConfig = generateConfig(
    writingConfigParams,
    'Schriftliches Benennen',
    true,
    shouldDisplay,
  );

  // Lesen
  const readingConfigParams = [Lesen.Richtig, Lesen.Falsch];
  const readingConfig = generateConfig(
    readingConfigParams,
    'Lesesinnverständnis',
    false,
    shouldDisplay,
  );
  return { understandingConfig, speakingConfig, writingConfig, readingConfig };
};

let gradient6 = [
  '#00AD93',
  '#2A87BC',
  '#5561E6',
  '#A630F2',
  '#F700FF',
  '#FF00A2',
];
let gradient10 = [
  '#52AAD0',
  '#159AA7',
  '#2A87BC',
  '#3F74D1',
  '#5561E6',
  '#7D48EC',
  '#A630F2',
  '#CE18F8',
  '#F700FF',
  '#FB00D0',
];

let bigLine = 12;
let smallLine = 2;
let bigRadius = 10;
let smallRadius = 5;

let greenRedYellow = ['#51BF92', '#de4747', '#F0B840'];

function sortByIndex(a, b) {
  return a.index - b.index;
}

function sortByDate(a, b) {
  return a[0] - b[0];
}

//TODO: Remove FastData for performance optimization where not needed
export function generateSeries(data) {
  try {
    if (data.length === 0) return;
    let timeSeries = data.series.timeSeries[0];
    let editSeries = {
      data: [],
      name: 'Übungsset bearbeitet',
      color: '#49475b',
      index: 5,
      lineWidth: 0,
      marker: { radius: bigRadius },
    };
    data.series.modificationSeries.forEach(function (edit) {
      editSeries.data.push([
        Date.UTC(edit._id.year, edit._id.month - 1, edit._id.day),
        0,
      ]);
    });
    // Reformatting the Series for Highcharts Before Response return
    let overviewSeries = [];
    timeSeries.overviewSeries.forEach(function (curve) {
      let highchartSeries = {};
      highchartSeries.exerciseType = curve._id.exerciseType;
      //Note: Date.UTC month is 0 to 11 whereas mongodb output month is 1 to 12
      if (
        curve._id.exerciseType === 'Schreiben' ||
        curve._id.exerciseType === 'Sprechen'
      ) {
        highchartSeries.richtigData = [];
        highchartSeries.fastData = [];
        curve.series.forEach(function (curvePoint) {
          highchartSeries.richtigData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.richtig * 100) / curvePoint.total,
          ]);
          highchartSeries.fastData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.fast * 100) / curvePoint.total,
          ]);
        });
        highchartSeries.fastData.sort(sortByDate);
      } else {
        highchartSeries.richtigData = [];
        curve.series.forEach(function (curvePoint) {
          highchartSeries.richtigData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.richtig * 100) / curvePoint.total,
          ]);
        });
      }
      highchartSeries.richtigData.sort(sortByDate);
      overviewSeries.push(highchartSeries);
    });

    let individualSeries = [];
    timeSeries.individualSeries.forEach(function (curve) {
      let highchartSeries = {};
      highchartSeries.exerciseType = curve._id.exerciseType;
      highchartSeries.setting = curve._id.setting;
      highchartSeries.value = curve._id.value;
      //Note: Date.UTC month is 0 to 11 whereas mongodb output month is 1 to 12
      if (
        curve._id.exerciseType === 'Schreiben' ||
        curve._id.exerciseType === 'Sprechen'
      ) {
        highchartSeries.richtigData = [];
        highchartSeries.fastData = [];
        curve.series.forEach(function (curvePoint) {
          highchartSeries.richtigData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.richtig * 100) / curvePoint.total,
          ]);
          highchartSeries.fastData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.fast * 100) / curvePoint.total,
          ]);
        });
        highchartSeries.fastData.sort(sortByDate);
      } else {
        highchartSeries.richtigData = [];
        curve.series.forEach(function (curvePoint) {
          highchartSeries.richtigData.push([
            Date.UTC(curvePoint.year, curvePoint.month - 1, curvePoint.day),
            (curvePoint.richtig * 100) / curvePoint.total,
          ]);
        });
      }
      highchartSeries.richtigData.sort(sortByDate);
      individualSeries.push(highchartSeries);
    });

    let overview = {};
    let series = {};

    series.Lesen = [];
    series.Schreiben = [];
    series.Sprechen = [];
    series.Verstehen = [];

    overviewSeries.forEach(function (ovSeries) {
      overview[ovSeries.exerciseType] = ovSeries.richtigData;
      if (ovSeries.exerciseType === 'Sprechen') {
        series[ovSeries.exerciseType].push({
          name: 'Gesamt richtig',
          data: ovSeries.richtigData,
          color: greenRedYellow[0],
          lineWidth: bigLine,
          marker: { radius: bigRadius },
        });

        // Uncomment to add Fast Richtig Series
        /*          series[ovSeries.exerciseType].push(
                                 {
                                 name: 'Fast richtig',
                                 data: ovSeries.fastData,
                                 color: greenRedYellow[2],
                                 lineWidth: bigLine,
                                 marker:  {radius: bigRadius}
                                 });*/
      } else {
        series[ovSeries.exerciseType].push({
          name: 'Gesamt richtig',
          data: ovSeries.richtigData,
          color: greenRedYellow[0],
          lineWidth: bigLine,
          marker: { radius: bigRadius },
          index: -1,
        });
      }
    });

    individualSeries.forEach(function (inSeries) {
      let name, color, index, marker;
      marker = { radius: smallRadius };
      if (
        inSeries.exerciseType === 'Verstehen' ||
        inSeries.exerciseType === 'Lesen'
      ) {
        if (inSeries.setting === 'unrelated') {
          marker = {
            radius: smallRadius,
            fillColor: 'white',
            lineWidth: 2,
            lineColor: null,
          };
        }
        if (inSeries.setting === 'unrelated' && inSeries.value === 2) {
          name = 'Zweier-Auswahl unrelatierte Ablenker';
          index = 0;
          color = gradient6[index];
        } else if (inSeries.setting === 'related' && inSeries.value === 2) {
          name = 'Zweier-Auswahl semantische Ablenker';
          index = 1;
          color = gradient6[index];
        } else if (inSeries.setting === 'fromset' && inSeries.value === 2) {
          name = 'Zweier-Auswahl Ablenker aus Set';
          index = 2;
          color = gradient6[index];
        } else if (inSeries.setting === 'unrelated' && inSeries.value === 3) {
          name = 'Dreier-Auswahl unrelatierte Ablenker';
          index = 3;
          color = gradient6[index];
        } else if (inSeries.setting === 'related' && inSeries.value === 3) {
          name = 'Dreier-Auswahl semantische Ablenker';
          index = 4;
          color = gradient6[index];
        } else if (inSeries.setting === 'fromset' && inSeries.value === 3) {
          name = 'Dreier-Auswahl Ablenker aus Set';
          index = 5;
          color = gradient6[index];
        } else if (inSeries.setting === 'unrelated' && inSeries.value === 4) {
          name = 'Vierer-Auswahl unrelatierte Ablenker';
          index = 6;
          color = gradient6[index];
        } else if (inSeries.setting === 'related' && inSeries.value === 4) {
          name = 'Vierer-Auswahl semantische Ablenker';
          index = 7;
          color = gradient6[index];
        } else if (inSeries.setting === 'fromset' && inSeries.value === 4) {
          name = 'Vierer-Auswahl Ablenker aus Set';
          index = 8;
          color = gradient6[index];
        }
        if (name) {
          series[inSeries.exerciseType].push({
            data: inSeries.richtigData,
            name: name,
            color: color,
            index: index,
            lineWidth: smallLine,
            marker: marker,
          });
        }
      } else if (inSeries.exerciseType === 'Schreiben') {
        if (inSeries.setting === 'gap') {
          name = 'Lückenwort /-satz ' + inSeries.value + ' Lücken';
          index = inSeries.value - 2;
          color = gradient10[index];
        } else if (inSeries.setting === 'anagram') {
          name = 'Anagramm ' + inSeries.value + ' Zusatzgrapheme /-wörter';
          index = inSeries.value + 4;
          color = gradient10[index];
          marker = {
            radius: smallRadius,
            fillColor: 'white',
            lineWidth: 2,
            lineColor: null,
          };
        } else if (inSeries.setting === 'full') {
          name = 'Ganze Tastatur';
          index = 9;
          color = gradient10[index];
        }

        if (name) {
          series[inSeries.exerciseType].push({
            data: inSeries.richtigData,
            name: name,
            color: color,
            index: index,
            lineWidth: smallLine,
            marker: marker,
          });
        }
      }
    });

    Object.keys(series).forEach(function (keySeries) {
      series[keySeries].sort(sortByIndex);
      series[keySeries].push(editSeries);
    });

    let returnObj = {};
    returnObj = series;
    returnObj.Overview = overview;
    return returnObj;
  } catch (_error) {
    return null;
  }
}

export function getChartConfig(seriesParam, nameParam) {
  try {
    if (seriesParam) {
      /* Alerting the JSON string of the controller. */
      let series = seriesParam;
      let height;
      if (series && series.length === 1) {
        height = 100;
      } else {
        height = 400;
      }
      let name = nameParam;
      let chartConfig = {
        lang: {
          months: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
        },
        // This is the Main Highcharts chart config. Any Highchart options are valid here.
        // will be overriden by values specified below.
        chart: {
          type: 'line',
          panning: false,
          pinchType: false,
          marginTop: 70,
          height: height,
        },
        title: {
          text: 'Verlauf ' + name,
          align: 'left',
          x: 55,
        },
        xAxis: {
          labels: {
            format: '{value:%e. %b}', // Display date without time
          },
          type: 'datetime',
          startOnTick: true,
          endOnTick: false,
          title: { text: 'Datum' },
        },
        yAxis: {
          title: { text: 'Korrekt %' },
          min: 0,
          max: 105,
          endOnTick: false,
          plotLines: [
            {
              value: 0,
              width: 1,
              color: '#51BF92',
            },
          ],
        },
        tooltip: {
          xDateFormat: '%d.%m.%Y',
          valueSuffix: ' %',
          valueDecimals: 0,
          snap: 0,
          followTouchMove: false,
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
          itemMarginBottom: 15,
          symbolHeight: 24,
        },
        // This would be used for printing if we had the highcharts exporting module
        // exporting: {
        //   enabled: !isMobile,
        //   fallbackToExportServer: false,
        //   buttons: {
        //     contextButton: {
        //       symbol: 'url(img/print.png)',
        //       symbolFill: '#B5C9DF',
        //       hoverSymbolFill: '#779ABF',
        //       onclick: function () {
        //         this.print();
        //       },
        //     },
        //   },
        // },
        credits: {
          enabled: false,
        },

        //The below properties are watched separately for changes.
        //Series object (optional) - a list of series using normal Highcharts series options.
        //series: series,
      };
      chartConfig.series = [];
      addNullValues(series);
      let maxDate, minDate;
      series.forEach(function (thisSeries) {
        let confObj = {
          name: thisSeries.name,
          lineWidth: thisSeries.lineWidth,
          marker: thisSeries.marker,
          color: thisSeries.color,
          stickyTracking: false,
        };

        if (thisSeries.name == 'Übungsset bearbeitet') {
          confObj.data = [...thisSeries.data];
          confObj.marker.symbol =
            'url(data:image/png;base64,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)';
          confObj.marker.height = 24;
          confObj.marker.width = 24;
          confObj.enableMouseTracking = false;
          confObj.allowPointSelect = false;
          // Remove Wordset edit entrys that are behind or before last result
          for (let i = confObj.data.length - 1; i >= 0; i--) {
            if (
              minDate === undefined ||
              confObj.data[i][0] > maxDate ||
              confObj.data[i][0] < minDate
            ) {
              confObj.data.splice(i, 1);
            }
          }
        } else {
          confObj.data = thisSeries.data;
        }

        // Style Marker if is Wordset editied series
        if (
          thisSeries.name === 'Richtig' ||
          thisSeries.name == 'Gesamt richtig'
        ) {
          minDate = thisSeries.data[0][0];
          maxDate = thisSeries.data[thisSeries.data.length - 1][0];
        }

        if (confObj.data.length > 0) {
          chartConfig.series.push(confObj);
        }
      });
      // This code is responsible for removing the hover effect of legend items (buttons filter under the chart) so we dont have the transparent issue stated in ticker RAA-473
      chartConfig.plotOptions = {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      };
      return chartConfig;
    }
  } catch (error) {
    logError('Could not get chart config', error);
    return {};
  }
}

function addNullValues(series) {
  if (series && series[0] !== undefined) {
    for (let i = 0; i < series[0].data.length; i++) {
      for (let j = 1; j < series.length; j++) {
        if (
          series[j].name !== 'Übungsset bearbeitet' &&
          series[j].data[i] !== undefined
        ) {
          if (series[0].data[i][0] < series[j].data[i][0]) {
            series[j].data.splice(i, 0, [series[0].data[i][0], null]);
          }
        }
      }
    }
  }
}
